/**
 * 管理画面フレームワークの公開口。
 *
 * 画面定義は src/data/admin-screens.json に置く。
 * **コードを書かずに章を増やせる**のがこの仕組みの目的なので、
 * ここには「章ごとの分岐」を一切書かない。
 */

import type { AdminScreen } from '../../types/admin';

export { AdminScreenView, findAdminScreen, type AdminHooks } from './screen';
export { formatValue, readArray, readField, readPath } from './paths';
export {
  PLACEHOLDER_KEYS,
  resolveEffects,
  substitute,
  type PlaceholderMap,
  type PlaceholderValue,
} from './placeholders';

/**
 * 画面定義を読み込む。
 *
 * admin-screens.json はデータ担当が用意する。まだ無い段階でも
 * ビルドとテストが通るよう、静的 import ではなく glob で任意扱いにしている
 * （ファイルが無ければ空配列になるだけ）。
 */
export function loadAdminScreens(): AdminScreen[] {
  const modules = import.meta.glob('../../data/admin-screens.json', { eager: true }) as Record<
    string,
    { default?: unknown }
  >;
  for (const key of Object.keys(modules)) {
    const data = modules[key]?.default;
    if (Array.isArray(data)) return data as AdminScreen[];
    // { "screens": [...] } の形も許す
    if (data && typeof data === 'object') {
      const screens = (data as { screens?: unknown }).screens;
      if (Array.isArray(screens)) return screens as AdminScreen[];
    }
    console.warn('[admin] admin-screens.json の形式が想定と違います');
  }
  return [];
}
